import { reduxSetter } from '../../../../../utils/reduxSetter';
import { SET_LEAD_PAYMENT_APPROVAL_DATA, SET_LEAD_PAYMENT_APPROVAL_DETAILS_DATA } from '../../constants';
import { buildState } from '../../../../../common/factories/reduxState';

const initialState = buildState({
    filters: {
        vrm: '',
        waitingApproval: 'all',
    },
    approvalDetails: buildState({
        $isNew: true,
        dataModel: null,
        catalogs: {
            drivers: buildState({
                filters: { searchByName: '' },
            }),
        },
    }),
});

export const LeadPaymentApproval = (state = initialState, action) => {
    switch (action.type) {
    case SET_LEAD_PAYMENT_APPROVAL_DATA:
        if (!Reflect.has(action.payload, 'isLoading') && state.isLoading) {
            return state;
        }

        return reduxSetter(state, action);
    case SET_LEAD_PAYMENT_APPROVAL_DETAILS_DATA:
        reduxSetter(state.approvalDetails, action);

        return { ...state };
    default:
        return state;
    }
};



// WEBPACK FOOTER //
// ./src/modules/Leads/LeadPaymentApproval/redux/reducers/index.js